export default __webpack_public_path__ + "static/media/SangliMart.3f5186c6.png";